export default [
  {
    path: "/app/school",
    component: () => import("../views"),
    meta: {
      title: "Educasis - Escola",
      requiresAuth: true,
    },
    children: [
      /* Register */
      /* Students */
      {
        path: "register/student",
        name: "school.register.student",
        component: () => import("../register/students/views/List"),
        meta: {
          permission: "view_student",
        },
      },

      {
        path: "register/student/create",
        name: "school.register.student.create",
        component: () => import("../register/students/views/Create"),
        meta: {
          permission: "view_student",
        },
      },
      {
        path: "register/student/show/:id",
        name: "school.register.student.show",
        component: () => import("../register/students/views/Show"),
        meta: {
          permission: "view_student",
        },
      },
      /* REGISTRATION */
      {
        path:
          "register/registrations/create-registration/:id/:name_student/:birthday",
        name: "school.register.registrations.create-registration",
        component: () =>
          import("../register/students/registrations/views/Create.vue"),
        meta: {
          permission: "view_student",
        },
      },
      {
        path:
          "register/registration/show/:cod_registration/:cod_student/:name_student/:school/:school_id/:course/:course_id/:grade/:grade_id/:group/:group_id/:entrance/:enrollment/:situation/:graduate/:modality_teaching/:exit_school/:exit_school_date/:observation/:type_aee",
        name: "school.register.registrations.show",
        component: () =>
          import("../register/students/registrations/views/Show.vue"),
        meta: {
          permission: "view_student",
        },
      },
      /* DISMISS-COMPONENTS */
      {
        path:
          "register/registrations/dismiss-disciplines/:cod_registration/:cod_student/:name_student/:school/:school_id/:course/:course_id/:grade/:grade_id/:group/:group_id/:entrance/:enrollment/:situation/:graduate/:modality_teaching/:exit_school/:exit_school_date/:observation/:type_aee",
        name: "school.register.registrations.dismiss-disciplines",
        component: () =>
          import(
            "../register/students/registrations/components/dismiss-disciplines/views/List"
          ),
        meta: {
          permission: "view_student",
        },
      },
      {
        path:
          "register/registrations/dismiss-disciplines/create/:cod_registration/:cod_student/:name_student/:school/:school_id/:course/:course_id/:grade/:grade_id/:group/:group_id/:entrance/:enrollment/:situation/:graduate/:modality_teaching/:exit_school/:exit_school_date/:observation/:type_aee",
        name: "school.register.registrations.dismiss-disciplines/create",
        component: () =>
          import(
            "../register/students/registrations/components/dismiss-disciplines/views/Create"
          ),
        meta: {
          permission: "view_student",
        },
      },
      {
        path:
          "register/registrations/dismiss-disciplines/edit/:id/:cod_registration/:cod_student/:name_student/:school/:school_id/:course/:course_id/:grade/:grade_id/:group/:group_id/:entrance/:enrollment/:situation/:graduate/:modality_teaching/:exit_school/:exit_school_date/:observation/:type_aee",
        name: "school.register.registrations.dismiss-disciplines/edit",
        component: () =>
          import(
            "../register/students/registrations/components/dismiss-disciplines/views/Edit"
          ),
        meta: {
          permission: "view_student",
        },
      },
      /* REGISTRATION GROUP */
      {
        path:
          "register/registrations/registration-group/:cod_registration/:cod_student/:name_student/:school/:school_id/:course/:course_id/:grade/:grade_id/:group/:group_id/:entrance/:enrollment/:situation/:graduate/:modality_teaching/:exit_school/:exit_school_date/:observation/:type_aee",
        name: "school.register.registrations.registration-group",
        component: () =>
          import(
            "../register/students/registrations/components/registration-group/views/List.vue"
          ),
        meta: {
          permission: "view_student",
        },
      },
      {
        path:
          "register/registrations/registration-group/create/:cod_registration/:cod_student/:name_student/:school/:school_id/:course/:course_id/:grade/:grade_id/:group/:group_id/:entrance/:enrollment/:situation/:graduate/:modality_teaching/:exit_school/:exit_school_date/:observation/:type_aee/:group_selected/:group_selected_id",
        name: "school.register.registrations.registration-group.create",
        component: () =>
          import(
            "../register/students/registrations/components/registration-group/views/Create.vue"
          ),
        meta: {
          permission: "view_student",
        },
      },
      /* MODALITY TEACHING */
      {
        path:
          "register/registrations/modality-teaching/:cod_registration/:cod_student/:name_student/:school/:school_id/:course/:course_id/:grade/:grade_id/:group/:group_id/:entrance/:enrollment/:situation/:graduate/:modality_teaching/:exit_school/:exit_school_date/:observation/:type_aee",
        name: "school.register.registrations.modality-teaching",
        component: () =>
          import(
            "../register/students/registrations/components/modality-teaching/index.vue"
          ),
        meta: {
          permission: "view_student",
        },
      },
      /* ABANDONMENT */
      {
        path:
          "register/registrations/abandonment/:cod_registration/:cod_student/:name_student/:school/:school_id/:course/:course_id/:grade/:grade_id/:group/:group_id/:entrance/:enrollment/:situation/:graduate/:modality_teaching/:exit_school/:exit_school_date/:observation/:type_aee",
        name: "school.register.registrations.abandonment",
        component: () =>
          import(
            "../register/students/registrations/components/abandonment/index.vue"
          ),
        meta: {
          permission: "view_student",
        },
      },
      /* DECEASED */
      {
        path:
          "register/registrations/deceased/:cod_registration/:cod_student/:name_student/:school/:school_id/:course/:course_id/:grade/:grade_id/:group/:group_id/:entrance/:enrollment/:situation/:graduate/:modality_teaching/:exit_school/:exit_school_date/:observation/:type_aee",
        name: "school.register.registrations.deceased",
        component: () =>
          import(
            "../register/students/registrations/components/deceased/index.vue"
          ),
        meta: {
          permission: "view_student",
        },
      },
      /* RECLASSIFY */
      {
        path:
          "register/registrations/reclassify/:cod_registration/:cod_student/:name_student/:school/:school_id/:course/:course_id/:grade/:grade_id/:group/:group_id/:entrance/:enrollment/:situation/:graduate/:modality_teaching/:exit_school/:exit_school_date/:observation/:type_aee",
        name: "school.register.registrations.reclassify",
        component: () =>
          import(
            "../register/students/registrations/components/reclassify/index.vue"
          ),
        meta: {
          permission: "view_student",
        },
      },
      /* REQUEST TRANSFER */
      {
        path:
          "register/registrations/request-transfer/:cod_registration/:cod_student/:name_student/:school/:school_id/:course/:course_id/:grade/:grade_id/:group/:group_id/:entrance/:enrollment/:situation/:graduate/:modality_teaching/:exit_school/:exit_school_date/:observation/:type_aee",
        name: "school.register.registrations.request-transfer",
        component: () =>
          import(
            "../register/students/registrations/components/request-transfer/index.vue"
          ),
        meta: {
          permission: "view_student",
        },
      },
      /* HISTORY REGISTRATION */
      {
        path:
          "register/registrations/history-registration/:cod_registration/:cod_student/:name_student/:school/:school_id/:course/:course_id/:grade/:grade_id/:group/:group_id/:entrance/:enrollment/:situation/:graduate/:modality_teaching/:exit_school/:exit_school_date/:observation/:type_aee",
        name: "school.register.registrations.history-registration",
        component: () =>
          import(
            "../register/students/registrations/components/history-registration/views/List.vue"
          ),
        meta: {
          permission: "view_student",
        },
      },
      {
        path:
          "register/registrations/history-registration/edit/:sequential/:cod_registration/:cod_student/:name_student/:school/:school_id/:course/:course_id/:grade/:grade_id/:group/:group_id/:entrance/:enrollment/:situation/:graduate/:modality_teaching/:exit_school/:exit_school_date/:observation/:type_aee",
        name: "school.register.registrations.history-registration.edit",
        component: () =>
          import(
            "../register/students/registrations/components/history-registration/views/Edit.vue"
          ),
        meta: {
          permission: "view_student",
        },
      },
      /*******************************************************************
        CALENDAR SCHOOL
       ********************************************************************/
      {
        path: "calendar",
        name: "school.register.calendar",
        component: () => import("../register/calendar/views/List"),
        meta: {
          permission: "view_calendar_year_school",
        },
      },
      {
        path: "calendar/create",
        name: "school.register.calendar.create",
        component: () => import("../register/calendar/views/Create"),
        meta: {
          permission: "view_calendar_year_school",
        },
      },
      /* EXIT SCHOOL */
      {
        path:
          "register/registrations/exit-school/:cod_registration/:cod_student/:name_student/:school/:school_id/:course/:course_id/:grade/:grade_id/:group/:group_id/:entrance/:enrollment/:situation/:graduate/:modality_teaching/:exit_school/:exit_school_date/:observation/:type_aee",
        name: "school.register.registrations.exit-school",
        component: () =>
          import(
            "../register/students/registrations/components/exit-school/index.vue"
          ),
        meta: {
          permission: "view_student",
        },
      },
      /* TYPE AEE STUDENT */
      {
        path:
          "register/registrations/type-aee-student/:cod_registration/:cod_student/:name_student/:school/:school_id/:course/:course_id/:grade/:grade_id/:group/:group_id/:entrance/:enrollment/:situation/:graduate/:modality_teaching/:exit_school/:exit_school_date/:observation/:type_aee",
        name: "school.register.registrations.type-ae",
        component: () =>
          import(
            "../register/students/registrations/components/type-aee-student/index.vue"
          ),
        meta: {
          permission: "view_student",
        },
      },
      /* REENROLLMENT AUTOMATIC */
      {
        path: "movements/reenrollment-automatic",
        name: "school.movements.reenrollment-automatic",
        component: () =>
          import("../movements/reenrollment-automatic/index.vue"),
        meta: {
          permission: "add_reenrollment_automatic",
        },
      },


      /* Institution */
      {
        path: "register/institution",
        name: "school.register.institution",
        component: () => import("../register/institution/views/List"),
        meta: {
          permission: "view_institution",
        },
      },
      {
        path: "register/institution/create",
        name: "school.register.institution.create",
        component: () => import("../register/institution/views/Create"),
        meta: {
          permission: "view_institution",
        },
      },
      {
        path: "register/institution/edit/:id",
        name: "school.register.institution.edit",
        component: () => import("../register/institution/views/Edit"),
        meta: {
          permission: "view_institution",
        },
      },
      /* Evaluation Rule */
      {
        path: "register/evaluation-rule",
        name: "school.register.evaluation-rule",
        component: () => import("../register/evaluation-rule/views/List"),
        meta: {
          permission: "view_evaluation_rule",
        },
      },
      {
        path: "register/evaluation-rule/create",
        name: "school.register.evaluation-rule.create",
        component: () => import("../register/evaluation-rule/views/Create"),
        meta: {
          permission: "view_evaluation_rule",
        },
      },
      {
        path: "register/evaluation-rule/show/:id",
        name: "school.register.evaluation-rule.show",
        component: () => import("../register/evaluation-rule/views/Show"),
        meta: {
          permission: "view_evaluation_rule",
        },
      },
      {
        path: "register/evaluation-rule/edit/:id",
        name: "school.register.evaluation-rule.edit",
        component: () => import("../register/evaluation-rule/views/Edit"),
        meta: {
          permission: "view_evaluation_rule",
        },
      },
      /* PROCESS */
      {
        path: "process/:id?",
        name: "school.process.historic-school",
        component: () => import("../process/historic_school/views/List"),
        meta: {
          permission: "view_historic_school",
        },
      },
      {
        path: "process/show/student/:id",
        name: "school.process.historic-school.show",
        component: () => import("../process/historic_school/views/Show"),
        meta: {
          permission: "view_historic_school",
        },
      },
      {
        path: "/process/bot-service",
        name: "school.process.bot-service",
        component: () => import("../process/bot-service/views/List.vue"),
        meta: {
          permission: "view_bot_service",
        },
      },
      {
        path: "/process/pre-enrollment",
        name: "school.pre-enrollment",
        component: () =>
          import("../pre-enrollment/pre-enrollment/views/List.vue"),
        meta: {
          permission: "view_pre_enrollment",
        },
      },
      {
        path: "/process/pre-enrollment/create",
        name: "school.pre-enrollment.create",
        component: () =>
          import("../pre-enrollment/pre-enrollment/views/Create.vue"),
        meta: {
          permission: "view_pre_enrollment",
        },
      },
      {
        path: "/process/pre-enrollment/edit/:id",
        name: "school.pre-enrollment.edit",
        component: () =>
          import("../pre-enrollment/pre-enrollment/views/Edit.vue"),
        meta: {
          permission: "view_pre_enrollment",
        },
      },
      {
        path: "/process/pre-enrollment/enrollment",
        name: "school.pre-enrollment.enrollment",
        component: () => import("../pre-enrollment/enrollment/views/List.vue"),
        meta: {
          permission: "view_pre_enrollment",
        },
      },
      /* Types */
      /* Students */
      /* Benefits */
      {
        path: "register/types/students/benefits",
        name: "school.register.type.students.benefits",
        component: () => import("../type/students/benefits/views/List"),
        meta: {
          permission: "view_benefit",
        },
      },
      {
        path: "register/types/students/benefits/create",
        name: "school.register.type.students.benefits.create",
        component: () => import("../type/students/benefits/views/Create"),
        meta: {
          permission: "view_benefit",
        },
      },
      {
        path: "register/types/students/benefits/edit/:id",
        name: "school.register.type.students.benefits.edit",
        component: () => import("../type/students/benefits/views/Edit"),
        meta: {
          permission: "view_benefit",
        },
      },
      /* Projects */
      {
        path: "register/types/students/projects",
        name: "school.register.type.students.projects",
        component: () => import("../type/students/projects/views/List.vue"),
        meta: {
          permission: "view_type_projects",
        },
      },
      {
        path: "register/types/students/projects/create",
        name: "school.register.type.students.projects.create",
        component: () => import("../type/students/projects/views/Create.vue"),
        meta: {
          permission: "view_type_projects",
        },
      },
      {
        path: "register/types/students/projects/edit/:id",
        name: "school.register.type.students.projects.edit",
        component: () => import("../type/students/projects/views/Edit.vue"),
        meta: {
          permission: "view_type_projects",
        },
      },
      {
        path: "register/types/students/projects/show/:id",
        name: "school.register.type.students.projects.show",
        component: () => import("../type/students/projects/views/Show.vue"),
        meta: {
          permission: "view_type_projects",
        },
      },
      /* Calendars */
      /* Calendar Events */
      {
        path: "register/types/calendars/calendar-events",
        name: "school.register.type.calendars.calendar-events",
        component: () =>
          import("../type/calendars/calendar-events/views/List.vue"),
        meta: {
          permission: "view_calendar_day_reason",
        },
      },
      {
        path: "register/types/calendars/calendar-events/create",
        name: "school.register.type.calendars.calendar-events.create",
        component: () =>
          import("../type/calendars/calendar-events/views/Create.vue"),
        meta: {
          permission: "view_calendar_day_reason",
        },
      },
      {
        path: "register/types/calendars/calendar-events/edit/:id",
        name: "school.register.type.calendars.calendar-events.edit",
        component: () =>
          import("../type/calendars/calendar-events/views/Edit.vue"),
        meta: {
          permission: "view_calendar_day_reason",
        },
      },
      {
        path: "register/types/calendars/calendar-events/show/:id",
        name: "school.register.type.calendars.calendar-events.show",
        component: () =>
          import("../type/calendars/calendar-events/views/Show.vue"),
        meta: {
          permission: "view_calendar_day_reason",
        },
      },
      /* Courses */
      /* Education Levels */
      {
        path: "register/types/courses/education-levels",
        name: "school.register.type.courses.education-levels",
        component: () =>
          import("../type/courses/education-levels/views/List.vue"),
        meta: {
          permission: "view_type_education_level",
        },
      },
      {
        path: "register/types/courses/education-levels/create",
        name: "school.register.type.courses.education-levels.create",
        component: () =>
          import("../type/courses/education-levels/views/Create.vue"),
        meta: {
          permission: "view_type_education_level",
        },
      },
      {
        path: "register/types/courses/education-levels/edit/:id",
        name: "school.register.type.courses.education-levels.edit",
        component: () =>
          import("../type/courses/education-levels/views/Edit.vue"),
        meta: {
          permission: "view_type_education_level",
        },
      },
      {
        path: "register/types/courses/education-levels/show/:id",
        name: "school.register.type.courses.education-levels.show",
        component: () =>
          import("../type/courses/education-levels/views/Show.vue"),
        meta: {
          permission: "view_type_education_level",
        },
      },
      /* Education Types */
      {
        path: "register/types/courses/education-types",
        name: "school.register.type.courses.education-types",
        component: () =>
          import("../type/courses/education-types/views/List.vue"),
        meta: {
          permission: "view_type_education",
        },
      },
      {
        path: "register/types/courses/education-types/create",
        name: "school.register.type.courses.education-types.create",
        component: () =>
          import("../type/courses/education-types/views/Create.vue"),
        meta: {
          permission: "view_type_education",
        },
      },
      {
        path: "register/types/courses/education-types/edit/:id",
        name: "school.register.type.courses.education-types.edit",
        component: () =>
          import("../type/courses/education-types/views/Edit.vue"),
        meta: {
          permission: "view_type_education",
        },
      },
      {
        path: "register/types/courses/education-types/show/:id",
        name: "school.register.type.courses.education-types.show",
        component: () =>
          import("../type/courses/education-types/views/Show.vue"),
        meta: {
          permission: "view_type_education",
        },
      },
      /* Habilitations */
      {
        path: "register/types/courses/habilitations",
        name: "school.register.type.courses.habilitations",
        component: () => import("../type/courses/habilitations/views/List.vue"),
        meta: {
          permission: "view_type_habilitation",
        },
      },
      {
        path: "register/types/courses/habilitations/create",
        name: "school.register.type.courses.habilitations.create",
        component: () =>
          import("../type/courses/habilitations/views/Create.vue"),
        meta: {
          permission: "view_type_habilitation",
        },
      },
      {
        path: "register/types/courses/habilitations/edit/:id",
        name: "school.register.type.courses.habilitations.edit",
        component: () => import("../type/courses/habilitations/views/Edit.vue"),
        meta: {
          permission: "view_type_habilitation",
        },
      },
      {
        path: "register/types/courses/habilitations/show/:id",
        name: "school.register.type.courses.habilitations.show",
        component: () => import("../type/courses/habilitations/views/Show.vue"),
        meta: {
          permission: "view_type_habilitation",
        },
      },
      /* Regime Types */
      {
        path: "register/types/courses/regime-types",
        name: "school.register.type.courses.regime-types",
        component: () => import("../type/courses/regime-types/views/List.vue"),
        meta: {
          permission: "view_type_regime",
        },
      },
      {
        path: "register/types/courses/regime-types/create",
        name: "school.register.type.courses.regime-types.create",
        component: () =>
          import("../type/courses/regime-types/views/Create.vue"),
        meta: {
          permission: "view_type_regime",
        },
      },
      {
        path: "register/types/courses/regime-types/edit/:id",
        name: "school.register.type.courses.regime-types.edit",
        component: () => import("../type/courses/regime-types/views/Edit.vue"),
        meta: {
          permission: "view_type_regime",
        },
      },
      {
        path: "register/types/courses/regime-types/show/:id",
        name: "school.register.type.courses.regime-types.show",
        component: () => import("../type/courses/regime-types/views/Show.vue"),
        meta: {
          permission: "view_type_regime",
        },
      },
      /* Curricular Components */
      /* Knowledge Areas */
      {
        path: "register/types/curricular-components/knowledge-areas",
        name: "school.register.type.curricular-components.knowledge-areas",
        component: () =>
          import(
            "../type/curricular-components/knowledge-areas/views/List.vue"
          ),
        meta: {
          permission: "view_type_knowledge_area",
        },
      },
      {
        path: "register/types/curricular-components/knowledge-areas/create",
        name:
          "school.register.type.curricular-components.knowledge-areas.create",
        component: () =>
          import(
            "../type/curricular-components/knowledge-areas/views/Create.vue"
          ),
        meta: {
          permission: "view_type_knowledge_area",
        },
      },
      {
        path: "register/types/curricular-components/knowledge-areas/edit/:id",
        name: "school.register.type.curricular-components.knowledge-areas.edit",
        component: () =>
          import(
            "../type/curricular-components/knowledge-areas/views/Edit.vue"
          ),
        meta: {
          permission: "view_type_knowledge_area",
        },
      },
      {
        path: "register/types/curricular-components/knowledge-areas/show/:id",
        name: "school.register.type.curricular-components.knowledge-areas.show",
        component: () =>
          import(
            "../type/curricular-components/knowledge-areas/views/Show.vue"
          ),
        meta: {
          permission: "view_type_knowledge_area",
        },
      },
      /* Dismissal */
      {
        path: "register/types/curricular-components/dismissals",
        name: "school.register.type.curricular-components.dismissals",
        component: () =>
          import("../type/curricular-components/dismissals/views/List.vue"),
        meta: {
          permission: "view_type_dismiss",
        },
      },
      {
        path: "register/types/curricular-components/dismissals/create",
        name: "school.register.type.curricular-components.dismissals.create",
        component: () =>
          import("../type/curricular-components/dismissals/views/Create.vue"),
        meta: {
          permission: "view_type_dismiss",
        },
      },
      {
        path: "register/types/curricular-components/dismissals/edit/:id",
        name: "school.register.type.curricular-components.dismissals.edit",
        component: () =>
          import("../type/curricular-components/dismissals/views/Edit.vue"),
        meta: {
          permission: "view_type_dismiss",
        },
      },
      {
        path: "register/types/curricular-components/dismissals/show/:id",
        name: "school.register.type.curricular-components.dismissals.show",
        component: () =>
          import("../type/curricular-components/dismissals/views/Show.vue"),
        meta: {
          permission: "view_type_dismiss",
        },
      },
      /* infraestructure */
      /* Buildings */
      {
        path: "register/types/infraestructure/buildings",
        name: "school.register.type.infraestructure.buildings",
        component: () =>
          import("../type/infraestructure/buildings/views/List.vue"),
        meta: {
          permission: "view_type_infra_building",
        },
      },
      {
        path: "register/types/infraestructure/buildings/create",
        name: "school.register.type.infraestructure.buildings.create",
        component: () =>
          import("../type/infraestructure/buildings/views/Create.vue"),
        meta: {
          permission: "view_type_infra_building",
        },
      },
      {
        path: "register/types/infraestructure/buildings/edit/:id",
        name: "school.register.type.infraestructure.buildings.edit",
        component: () =>
          import("../type/infraestructure/buildings/views/Edit.vue"),
        meta: {
          permission: "view_type_infra_building",
        },
      },
      {
        path: "register/types/infraestructure/buildings/show/:id",
        name: "school.register.type.infraestructure.buildings.show",
        component: () =>
          import("../type/infraestructure/buildings/views/Show.vue"),
        meta: {
          permission: "view_type_infra_building",
        },
      },
      /* Environment */
      {
        path: "register/types/infraestructure/environments",
        name: "school.register.type.infraestructure.environments",
        component: () =>
          import("../type/infraestructure/environments/views/List.vue"),
        meta: {
          permission: "view_type_infra_convenient_function",
        },
      },
      {
        path: "register/types/infraestructure/environments/create",
        name: "school.register.type.infraestructure.environments.create",
        component: () =>
          import("../type/infraestructure/environments/views/Create.vue"),
        meta: {
          permission: "view_type_infra_convenient_function",
        },
      },
      {
        path: "register/types/infraestructure/environments/edit/:id",
        name: "school.register.type.infraestructure.environments.edit",
        component: () =>
          import("../type/infraestructure/environments/views/Edit.vue"),
        meta: {
          permission: "view_type_infra_convenient_function",
        },
      },
      {
        path: "register/types/infraestructure/environments/show/:id",
        name: "school.register.type.infraestructure.environments.show",
        component: () =>
          import("../type/infraestructure/environments/views/Show.vue"),
        meta: {
          permission: "view_type_infra_convenient_function",
        },
      },
      /* Registrations */
      /* Abandonment */
      {
        path: "register/types/registrations/abandonments",
        name: "school.register.type.registrations.abandonments",
        component: () =>
          import("../type/registrations/abandonments/views/List.vue"),
        meta: {
          permission: "view_type_abandonments",
        },
      },
      {
        path: "register/types/registrations/abandonments/create",
        name: "school.register.type.registrations.abandonments.create",
        component: () =>
          import("../type/registrations/abandonments/views/Create.vue"),
        meta: {
          permission: "view_type_abandonments",
        },
      },
      {
        path: "register/types/registrations/abandonments/edit/:id",
        name: "school.register.type.registrations.abandonments.edit",
        component: () =>
          import("../type/registrations/abandonments/views/Edit.vue"),
        meta: {
          permission: "view_type_abandonments",
        },
      },
      {
        path: "register/types/registrations/abandonments/show/:id",
        name: "school.register.type.registrations.abandonments.show",
        component: () =>
          import("../type/registrations/abandonments/views/Show.vue"),
        meta: {
          permission: "view_type_abandonments",
        },
      },
      /* Occurrence Disciplinary */
      {
        path: "register/types/registrations/occurrences-disciplinary",
        name: "school.register.type.registrations.occurrences-disciplinary",
        component: () =>
          import(
            "../type/registrations/occurrences-disciplinary/views/List.vue"
          ),
        meta: {
          permission: "view_type_occurrence_disciplinary",
        },
      },
      {
        path: "register/types/registrations/occurrences-disciplinary/create",
        name:
          "school.register.type.registrations.occurrences-disciplinary.create",
        component: () =>
          import(
            "../type/registrations/occurrences-disciplinary/views/Create.vue"
          ),
        meta: {
          permission: "view_type_occurrence_disciplinary",
        },
      },
      {
        path: "register/types/registrations/occurrences-disciplinary/edit/:id",
        name:
          "school.register.type.registrations.occurrences-disciplinary.edit",
        component: () =>
          import(
            "../type/registrations/occurrences-disciplinary/views/Edit.vue"
          ),
        meta: {
          permission: "view_type_occurrence_disciplinary",
        },
      },
      {
        path: "register/types/registrations/occurrences-disciplinary/show/:id",
        name:
          "school.register.type.registrations.occurrences-disciplinary.show",
        component: () =>
          import(
            "../type/registrations/occurrences-disciplinary/views/Show.vue"
          ),
        meta: {
          permission: "view_type_occurrence_disciplinary",
        },
      },
      /* Transfer */
      {
        path: "register/types/registrations/transfers",
        name: "school.register.type.registrations.transfers",
        component: () =>
          import("../type/registrations/transfers/views/List.vue"),
        meta: {
          permission: "view_type_transfer",
        },
      },
      {
        path: "register/types/registrations/transfers/create",
        name: "school.register.type.registrations.transfers.create",
        component: () =>
          import("../type/registrations/transfers/views/Create.vue"),
        meta: {
          permission: "view_type_transfer",
        },
      },
      {
        path: "register/types/registrations/transfers/edit/:id",
        name: "school.register.type.registrations.transfers.edit",
        component: () =>
          import("../type/registrations/transfers/views/Edit.vue"),
        meta: {
          permission: "view_type_transfer",
        },
      },
      {
        path: "register/types/registrations/transfers/show/:id",
        name: "school.register.type.registrations.transfers.show",
        component: () =>
          import("../type/registrations/transfers/views/Show.vue"),
        meta: {
          permission: "view_type_transfer",
        },
      },
      /* Evaluation Rules */
      /* Average Calculation */
      {
        path: "register/types/evaluation-rules/average-formulas",
        name: "school.register.type.evaluation-rules.average-formulas",
        component: () =>
          import("../type/evaluation-rules/average-formulas/views/List.vue"),
        meta: {
          permission: "view_type_average_formulas",
        },
      },
      {
        path: "register/types/evaluation-rules/average-formulas/create",
        name: "school.register.type.evaluation-rules.average-formulas.create",
        component: () =>
          import("../type/evaluation-rules/average-formulas/views/Create.vue"),
        meta: {
          permission: "view_type_average_formulas",
        },
      },
      {
        path: "register/types/evaluation-rules/average-formulas/edit/:id",
        name: "school.register.type.evaluation-rules.average-formulas.edit",
        component: () =>
          import("../type/evaluation-rules/average-formulas/views/Edit.vue"),
        meta: {
          permission: "view_type_average_formulas",
        },
      },
      {
        path: "register/types/evaluation-rules/average-formulas/show/:id",
        name: "school.register.type.evaluation-rules.average-formulas.show",
        component: () =>
          import("../type/evaluation-rules/average-formulas/views/Show.vue"),
        meta: {
          permission: "view_type_average_formulas",
        },
      },
      /* Rounding Tables */
      {
        path: "register/types/evaluation-rules/rounding-tables",
        name: "school.register.type.evaluation-rules.rounding-tables",
        component: () =>
          import("../type/evaluation-rules/rounding-tables/views/List.vue"),
        meta: {
          permission: "view_type_rounding_tables",
        },
      },
      {
        path: "register/types/evaluation-rules/rounding-tables/create",
        name: "school.register.type.evaluation-rules.rounding-tables.create",
        component: () =>
          import("../type/evaluation-rules/rounding-tables/views/Create.vue"),
        meta: {
          permission: "view_type_rounding_tables",
        },
      },
      {
        path: "register/types/evaluation-rules/rounding-tables/edit/:id",
        name: "school.register.type.evaluation-rules.rounding-tables.edit",
        component: () =>
          import("../type/evaluation-rules/rounding-tables/views/Edit.vue"),
        meta: {
          permission: "view_type_rounding_tables",
        },
      },
      {
        path: "register/types/evaluation-rules/rounding-tables/show/:id",
        name: "school.register.type.evaluation-rules.rounding-tables.show",
        component: () =>
          import("../type/evaluation-rules/rounding-tables/views/Show.vue"),
        meta: {
          permission: "view_type_rounding_tables",
        },
      },
      /* Grades */
      /* Grade Components */
      {
        path: "register/types/grades/grade-components",
        name: "school.register.type.grades.grade-components",
        component: () =>
          import("../type/grades/grade-components/views/List.vue"),
        meta: {
          permission: "view_grade_components",
        },
      },
      {
        path: "register/types/grades/grade-components/create",
        name: "school.register.type.grades.grade-components.create",
        component: () =>
          import("../type/grades/grade-components/views/Create.vue"),
        meta: {
          permission: "view_grade_components",
        },
      },
      {
        path: "register/types/grades/grade-components/edit/:id",
        name: "school.register.type.grades.grade-components.edit",
        component: () =>
          import("../type/grades/grade-components/views/Edit.vue"),
        meta: {
          permission: "view_grade_components",
        },
      },
      /* SEQUENCES-ENROLLMENT*/
      {
        path: "/sequences-enrollment",
        name: "school.types.grades.sequences-enrollment",
        component: () =>
          import("../type/grades/sequences-enrollment/views/List.vue"),
        meta: {
          permission: "view_sequences_enrollment",
        },
      },
      {
        path: "/sequences-enrollment/create",
        name: "school.types.grades.sequences-enrollment.create",
        component: () =>
          import("../type/grades/sequences-enrollment/views/Create.vue"),
        meta: {
          permission: "view_sequences_enrollment",
        },
      },
      {
        path:
          "/sequences-enrollment/edit/:grade_origin_id/:grade_destination_id",
        name: "school.types.grades.sequences-enrollment.edit",
        component: () =>
          import("../type/grades/sequences-enrollment/views/Edit.vue"),
        meta: {
          permission: "view_sequences_enrollment",
        },
      },
      /* Groups */
      /* Group Types */
      {
        path: "register/types/groups/group-types",
        name: "school.register.type.groups.group-types",
        component: () => import("../type/groups/group-types/views/List.vue"),
        meta: {
          permission: "view_type_group",
        },
      },
      {
        path: "register/types/groups/group-types/create",
        name: "school.register.type.groups.group-types.create",
        component: () => import("../type/groups/group-types/views/Create.vue"),
        meta: {
          permission: "view_type_group",
        },
      },
      {
        path: "register/types/groups/group-types/edit/:id",
        name: "school.register.type.groups.group-types.edit",
        component: () => import("../type/groups/group-types/views/Edit.vue"),
        meta: {
          permission: "view_type_group",
        },
      },
      {
        path: "register/types/groups/group-types/show/:id",
        name: "school.register.type.groups.group-types.show",
        component: () => import("../type/groups/group-types/views/Show.vue"),
        meta: {
          permission: "view_type_group",
        },
      },
      /* Schools */
      /* School Locations */
      {
        path: "register/types/schools/school-locations",
        name: "school.register.types.schools.school-locations",
        component: () =>
          import("../type/schools/school-locations/views/List.vue"),
        meta: {
          permission: "view_type_school_location",
        },
      },
      {
        path: "register/types/schools/school-locations/create",
        name: "school.register.types.schools.school-locations.create",
        component: () =>
          import("../type/schools/school-locations/views/Create.vue"),
        meta: {
          permission: "view_type_school_location",
        },
      },
      {
        path: "register/types/schools/school-locations/edit/:id",
        name: "school.register.types.schools.school-locations.edit",
        component: () =>
          import("../type/schools/school-locations/views/Edit.vue"),
        meta: {
          permission: "view_type_school_location",
        },
      },
      {
        path: "register/types/schools/school-locations/show/:id",
        name: "school.register.types.schools.school-locations.show",
        component: () =>
          import("../type/schools/school-locations/views/Show.vue"),
        meta: {
          permission: "view_type_school_location",
        },
      },
      /* Educational Networks */
      {
        path: "register/types/schools/educational-networks",
        name: "school.register.types.schools.educational-networks",
        component: () =>
          import("../type/schools/educational-networks/views/List.vue"),
        meta: {
          permission: "view_type_educational_network",
        },
      },
      {
        path: "register/types/schools/educational-networks/create",
        name: "school.register.types.schools.educational-networks.create",
        component: () =>
          import("../type/schools/educational-networks/views/Create.vue"),
        meta: {
          permission: "view_type_educational_network",
        },
      },
      {
        path: "register/types/schools/educational-networks/edit/:id",
        name: "school.register.types.schools.educational-networks.edit",
        component: () =>
          import("../type/schools/educational-networks/views/Edit.vue"),
        meta: {
          permission: "view_type_educational_network",
        },
      },
      {
        path: "register/types/schools/educational-networks/show/:id",
        name: "school.register.types.schools.educational-networks.show",
        component: () =>
          import("../type/schools/educational-networks/views/Show.vue"),
        meta: {
          permission: "view_type_educational_network",
        },
      },
      /* Modules */
      {
        path: "register/types/schools/modules",
        name: "school.register.types.schools.modules",
        component: () => import("../type/schools/modules/views/List.vue"),
        meta: {
          permission: "view_module",
        },
      },
      {
        path: "register/types/modules/create",
        name: "school.register.types.schools.modules.create",
        component: () => import("../type/schools/modules/views/Create.vue"),
        meta: {
          permission: "view_module",
        },
      },
      {
        path: "register/types/schools/modules/edit/:id",
        name: "school.register.types.schools.modules.edit",
        component: () => import("../type/schools/modules/views/Edit.vue"),
        meta: {
          permission: "view_module",
        },
      },
      {
        path: "register/types/schools/modules/show/:id",
        name: "school.register.types.schools.modules.show",
        component: () => import("../type/schools/modules/views/Show.vue"),
        meta: {
          permission: "view_module",
        },
      },

      /* Curricular Components */
      {
        path: "curricular-components",
        name: "school.curricular-components",
        component: () => import("../register/curricular-components/views/List"),
        meta: {
          permission: "view_curricular_component",
        },
      },
      {
        path: "curricular-components/create",
        name: "school.curricular-components.create",
        component: () =>
          import("../register/curricular-components/views/Create"),
        meta: {
          permission: "view_curricular_component",
        },
      },
      {
        path: "curricular-components/edit/:id",
        name: "school.curricular-components.edit",
        component: () => import("../register/curricular-components/views/Edit"),
        meta: {
          permission: "view_curricular_component",
        },
      },

      /* Courses */
      {
        path: "courses",
        name: "school.courses",
        component: () => import("../register/courses/views/List"),
        meta: {
          permission: "view_course",
        },
      },
      {
        path: "courses/create",
        name: "school.courses.create",
        component: () => import("../register/courses/views/Create"),
        meta: {
          permission: "view_course",
        },
      },
      {
        path: "courses/edit/:id",
        name: "school.courses.edit",
        component: () => import("../register/courses/views/Edit"),
        meta: {
          permission: "view_course",
        },
      },
      {
        path: "courses/show/:id",
        name: "school.courses.show",
        component: () => import("../register/courses/views/Show"),
        meta: {
          permission: "view_course",
        },
      },

      /*  grade */
      {
        path: "grade",
        name: "school.grade",
        component: () => import("../register/grade/views/List"),
        meta: {
          permission: "view_grade",
        },
      },
      {
        path: "grade/create",
        name: "school.grade.create",
        component: () => import("../register/grade/views/Create"),
        meta: {
          permission: "view_grade",
        },
      },
      {
        path: "grade/edit/:id",
        name: "school.grade.edit",
        component: () => import("../register/grade/views/Edit"),
        meta: {
          permission: "view_grade",
        },
      },
      {
        path: "grade/show/:id",
        name: "school.grade.show",
        component: () => import("../register/grade/views/Show"),
        meta: {
          permission: "view_grade",
        },
      },

      /*  school-grade */
      {
        path: "school-grade",
        name: "school.school-grade",
        component: () => import("../register/school-grade/views/List"),
        meta: {
          permission: "view_school_grade",
        },
      },
      {
        path: "school-grade/create",
        name: "school.school-grade.create",
        component: () => import("../register/school-grade/views/Create"),
        meta: {
          permission: "view_school_grade",
        },
      },
      {
        path: "school-grade/edit/:id/:school_id",
        name: "school.school-grade.edit",
        component: () => import("../register/school-grade/views/Edit"),
        meta: {
          permission: "view_school_grade",
        },
      },
      {
        path: "school-grade/show/:id/:school_id",
        name: "school.school-grade.show",
        component: () => import("../register/school-grade/views/Show"),
        meta: {
          permission: "view_school_grade",
        },
      },

      /*  school */
      {
        path: "school",
        name: "school.school",
        component: () => import("../register/school/views/List"),
        meta: {
          permission: "view_school",
        },
      },
      {
        path: "school/create",
        name: "school.school.create",
        component: () => import("../register/school/views/Edit"),
        meta: {
          permission: "view_school",
        },
      },
      {
        path: "school/edit/:id",
        name: "school.school.edit",
        component: () => import("../register/school/views/Edit"),
        meta: {
          permission: "view_school",
        },
      },
      {
        path: "school/show/:id",
        name: "school.school.show",
        component: () => import("../register/school/views/Show"),
        meta: {
          permission: "view_school",
        },
      },
      /*Groups*/
      {
        path: "groups",
        name: "school.register.group",
        component: () => import("../register/group/views/List.vue"),
        meta: {
          permission: "view_group",
        },
      },
      {
        path: "groups/create",
        name: "school.register.group.create",
        component: () => import("../register/group/views/Create.vue"),
        meta: {
          permission: "view_group",
        },
      },
      {
        path: "groups/edit/:id",
        name: "school.register.group.edit",
        component: () => import("../register/group/views/Edit.vue"),
        meta: {
          permission: "view_group",
        },
      },
      /*School Year */
      {
        path: "school-year/:id",
        name: "school-year-stage",
        component: () => import("../school-year/views/Create.vue"),
        meta: {
          permission: "view_school",
        },
      },
      {
        path: "school-year/show/:id",
        name: "school-year-stage.show",
        component: () => import("../school-year/views/Show.vue"),
        meta: {
          permission: "view_school",
        },
      },
      {
        path: "school-year/edit/:id",
        name: "school-year-stage.edit",
        component: () => import("../school-year/views/Edit.vue"),
        meta: {
          permission: "view_school",
        },
      },
      /* Blocking Notes Absences */
      {
        path: "blocking-notes-absences",
        name: "school.params.blocking-notes-absences",
        component: () =>
          import("../params/blocking-notes-absences/views/List.vue"),
        meta: {
          permission: "view_blocking_notes_absences",
        },
      },
      {
        path: "blocking-notes-absences/create",
        name: "school.params.blocking-notes-absences.create",
        component: () =>
          import("../params/blocking-notes-absences/views/Create.vue"),
        meta: {
          permission: "view_blocking_notes_absences",
        },
      },
      {
        path: "blocking-notes-absences/edit/:id",
        name: "school.params.blocking-notes-absences.edit",
        component: () =>
          import("../params/blocking-notes-absences/views/Edit.vue"),
        meta: {
          permission: "view_blocking_notes_absences",
        },
      },
      {
        path: "blocking-notes-absences/show/:id",
        name: "school.params.blocking-notes-absences.show",
        component: () =>
          import("../params/blocking-notes-absences/views/Show.vue"),
        meta: {
          permission: "view_blocking_notes_absences",
        },
      },

      /* School Year Block*/
      {
        path: "school-year-block",
        name: "school.params.school-year-block",
        component: () => import("../params/school-year-block/views/List.vue"),
        meta: {
          permission: "view_school_year_block",
        },
      },
      {
        path: "school-year-block/create",
        name: "school.params.school-year-block.create",
        component: () => import("../params/school-year-block/views/Create.vue"),
        meta: {
          permission: "view_school_year_block",
        },
      },
      {
        path: "school-year-block/edit/:id",
        name: "school.params.school-year-block.edit",
        component: () => import("../params/school-year-block/views/Edit.vue"),
        meta: {
          permission: "view_school_year_block",
        },
      },
      {
        path: "school-year-block/show/:id",
        name: "school.params.school-year-block.show",
        component: () => import("../params/school-year-block/views/Show.vue"),
        meta: {
          permission: "view_school_year_block",
        },
      },

      /*class-registration*/
      {
        path: "movements/class-registration",
        name: "school.movements.class-registration",
        component: () =>
          import("../movements/class-registration/views/List.vue"),
        meta: {
          permission: "view_registration_group",
        },
      },
      {
        path: "movements/class-registration/show/:id",
        name: "school.movements.class-registration.show",
        component: () =>
          import("../movements/class-registration/views/Show.vue"),
        meta: {
          permission: "view_registration_group",
        },
      },
      {
        path: "movements/class-registration/copy",
        name: "school.movements.class-registration.copy",
        component: () =>
          import("../movements/class-registration/views/Copy.vue"),
        meta: {
          permission: "view_registration_group",
        },
      },

      /************************* Unification's ********************/
      /* STUDENT */
      {
        path: "unification-student",
        name: "school.tools.unification-student.list",
        component: () => import("../tools/unifications/student/views/List.vue"),
        meta: {
          permission: "view_unification_students",
        },
      },
      {
        path: "unification-student/create",
        name: "school.tools.unification-student.create",
        component: () =>
          import("../tools/unifications/student/views/Create.vue"),
        meta: {
          permission: "view_unification_students",
        },
      },
      {
        path: "unification-student/show/:id",
        name: "school.tools.unification-student.show",
        component: () => import("../tools/unifications/student/views/Show.vue"),
        meta: {
          permission: "view_unification_students",
        },
      },
      /* PERSON */
      {
        path: "unification-person",
        name: "school.tools.unification-person.list",
        component: () => import("../tools/unifications/person/views/List.vue"),
        meta: {
          permission: "view_unification_persons",
        },
      },
      {
        path: "unification-person/create",
        name: "school.tools.unification-person.create",
        component: () =>
          import("../tools/unifications/person/views/Create.vue"),
        meta: {
          permission: "view_unification_persons",
        },
      },
      /************************* Grades Vacancies ********************/
      {
        path: "grade-vacancy",
        name: "school.pre-enrollment.grade-vacancy",
        component: () =>
          import("../pre-enrollment/grade-vacancy/views/List.vue"),
        meta: {
          permission: "view_grade_vacancy",
        },
      },
      {
        path: "grade-vacancy/create",
        name: "school.pre-enrollment.grade-vacancy.create",
        component: () =>
          import("../pre-enrollment/grade-vacancy/views/Create.vue"),
        meta: {
          permission: "view_grade_vacancy",
        },
      },
      {
        path: "grade-vacancy/edit/:id",
        name: "school.pre-enrollment.grade-vacancy.edit",
        component: () =>
          import("../pre-enrollment/grade-vacancy/views/Edit.vue"),
        meta: {
          permission: "view_grade_vacancy",
        },
      },
      {
        path: "grade-vacancy/show/:id",
        name: "school.pre-enrollment.grade-vacancy.show",
        component: () =>
          import("../pre-enrollment/grade-vacancy/views/Show.vue"),
        meta: {
          permission: "view_grade_vacancy",
        },
      },
      {
        path: "grade-vacancy/copy/:id",
        name: "school.pre-enrollment.grade-vacancy.copy",
        component: () =>
          import("../pre-enrollment/grade-vacancy/views/Copy.vue"),
        meta: {
          permission: "view_grade_vacancy",
        },
      },

      /* REPORTS GRADE VACANCY */
      {
        path: "reports/grade-vacancy",
        name: "reports.grade-vacancy",
        component: () =>
          import("../pre-enrollment/reports-grade-vacancy/views/List.vue"),
        meta: {
          permission: "view_grade_vacancy",
        },
      },
    ],
  },
];
